<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'review'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('menu.productReview')}}</h1>
						</div>

						<div class="product-infos-wrapper-pc">
							<el-table :data="ratingList" style="width: 100%" v-loading="tableLoading"
								:empty-text="$t('empty.nodata')">
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="productName" :label="$t('common.productname')" min-width="180"></el-table-column>
								<el-table-column prop="customerName" :label="$t('order.customer')" width="120"></el-table-column>
								<el-table-column prop="rating" :label="$t('table.rating')" width="120">
									<template v-slot="scope">
										<el-rate v-model="scope.row.rating" disabled show-score
											score-template="{value}" />
									</template>
								</el-table-column>
								<el-table-column prop="comment" :label="$t('table.comment')" min-width="150"></el-table-column>
								<el-table-column prop="published" :label="$t('table.published')" width="120">
									<template v-slot="scope">
										<el-tag type="success">{{$t('table.published')}}</el-tag>
									</template>
								</el-table-column>
							</el-table>
						</div>

						<div class="product-infos-wrapper-mobile">
							<el-table :data="ratingList" style="width: 100%" v-loading="tableLoading">
								<el-table-column type="expand">
									<template v-slot="scope">
										<div class="expanded-content">
											<p><strong>{{$t('common.productname')}}:</strong> {{ scope.row.productName }}</p>
											<p><strong>{{$t('table.comment')}}:</strong> {{ scope.row.comment }}</p>
											<p><strong>{{$t('table.published')}}:</strong>
												<el-tag type="success">{{$t('table.published')}}</el-tag>
											</p>
										</div>
									</template>
								</el-table-column>
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="customerName" :label="$t('order.customer')"></el-table-column>
								<el-table-column :label="$t('table.rating')">
									<template v-slot="scope">
										<el-rate v-model="scope.row.rating" disabled show-score />
									</template>
								</el-table-column>
							</el-table>
						</div>
						<!-- 分页组件 -->
						<div class="page-contrainer d-flex">
							<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next" :total="total"
								:current-page.sync="pageNo" @current-change="handleCurrentChange"
								@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		ratingList
	} from "@/api/product";
	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				total: 0,
				tableLoading: false,
				ratingList: [],
				tableTotal: 100,
				pageNo: 1,
				isMobile:false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getRatingList();
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getRatingList() {
				let queryParams = {
					pageNo: this.pageNo,
					pageSize: 10
				}
				ratingList(queryParams).then(res => {
					if (res.code === 200) {
						this.ratingList = res.rows;
						this.total = res.total;
					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/review.css");
</style>
<style scoped>
	.product-infos-wrapper-mobile {
		display: none;
	}

	.product-infos-wrapper-pc {
		display: block;
	}

	@media (max-width: 768px) {
		.product-infos-wrapper-mobile {
			display: block;
		}

		.product-infos-wrapper-pc {
			display: none;
		}

	}
</style>
